import { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const checkboxOverride: CheckboxDesignTokens = {
  root: {
    borderRadius: getRem(4),
    width: getRem(24),
    height: getRem(24),
    checkedBackground: getColor('SeaBlue'),
    checkedHoverBackground: getColor('SkyBlue45'),
    checkedHoverBorderColor: getColor('SkyBlue45'),
    disabledBackground: getColor('Sandstone95'),
    hoverBorderColor: getColor('SkyBlue55'),
  },
  icon: {
    color: getColor('UiWhite'),
    checkedColor: getColor('UiWhite'),
    size: getRem(14),
  },
};
